import { useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import accountStyles from './account-styles';
import toast from 'react-hot-toast';
import { set } from 'lodash';
import Title from '../../components/Account/Title';
import UserContext from '../../hooks/UserContext';
import Api from '../../utils/Api';
import SelectUser from '../../components/SelectUser';
import { useNavigate } from 'react-router-dom';
import UserCard from '../../components/UserCard';
import ConfirmButton from '../../components/ConfirmButton';


const proxyCss = css`
display: flex;
flex-direction: column;
gap: 20px;
& .section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  & .title {
    font-weight: bold;
  }
}
.button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
  `
const ProxySettings = styled(({ className }) => {
  const { proxyAs, updateUser, user } = useContext(UserContext);
  const [proxyFor, setProxyFor] = useState(null);
  const [allowProxy, setAllowProxy] = useState(null);
  const navigate = useNavigate();

  const startProxy = async () => {
    if (proxyFor) {
      const [error,] = await proxyAs(proxyFor);
      if (error) return toast.error(Api.error(error));
      else return navigate('/');
    }
  }

  const updateAllowProxy = async () => {
    setAllowProxy(null);
    const [error, updatedUser] = await Api.updateAllowProxy(allowProxy);
    if (error) return toast.error(Api.error(error));
    else {
      updateUser(updatedUser);
      return toast.success('Allow Proxy has been updated');
    }
  }

  return (
    <div className={className}>
      <div className='section'>
        <div className='title'>Allow User To Proxy</div>
        {
          user.allowProxy
            ? <div className='button-row'>
              <ConfirmButton 
                className='danger'
                confirm = 'Yes'
                cancel = 'No'
                text = {`The person you selected to proxy on your behalf will no longer be able to do so until you add them again. 
                         Do you wish to remove them?`}
                onCancel = {() => {}}
                onConfirm={() => updateAllowProxy(null)}>
                  Clear Allow Proxy
              </ConfirmButton>
              <div><UserCard user={user.allowProxy} /></div>
            </div>
            : <>
              <SelectUser onSelect={user => setAllowProxy(user)} />
              <div className='button-row'>
                <ConfirmButton
                 disabled={!allowProxy} 
                 className='primary' 
                 confirm = 'Yes'
                 cancel = 'No'
                 onCancel = {() => setAllowProxy(null)}
                 text = {`The person you selected to proxy on your behalf will be able to access all aspects of
                          your account, and create content with your account information. Do you wish to allow this?`}
                 onConfirm={updateAllowProxy}>
                  Allow User
                  </ConfirmButton>
                {allowProxy && <div><UserCard user={allowProxy} /></div>}
              </div>
            </>
        }

      </div>
      <div className='section'>
        <div className='title'>Start Proxy For User</div>
        <SelectUser onSelect={user => setProxyFor(user)} />
        <span className='button-row'>
          <ConfirmButton 
          disabled={!proxyFor} 
          className='primary' 
          text = {`By confirming, you understand that you will be logged in as the selected user. 
                   Any activity will be as if you were logged into their account.  Do you wish to
                   continue?`}
          confirm = 'Yes'
          cancel = 'No'
          onCancel = {()=> {}}
          onConfirm={startProxy}>
            Start Proxy Session
          </ConfirmButton>
          {proxyFor && <div><UserCard user={proxyFor} /></div>}
        </span>
      </div>

    </div>
  )
})`${proxyCss}`;


const notificationStyles = css`
display: flex;
flex-direction: column;
gap: 10px;

  & .setting {
    height: 2em;
    width: 2em;
  }
  & .row {
    display: grid;
    grid-template-columns: 2fr .5fr .5fr .5fr;
    justify-items: center; 
    align-items: center;
    //height: 3em;
    gap: 5px;
 
    &.heading {
      font-weight: bold;
    }

    & .category {
      justify-self: left;
    }
  }

`
const NotificationsList = styled(({ className }) => {
  const { user: { settings: { notifications = {} } = {} }, updateUser } = useContext(UserContext);
  const NOTIFICATIONS_LABELS = {
    personLeftGroup: "Someone leaves a group",
    newPersonInGroup: "Someone joins a group",
    newListInGroup: "A new list is shared in a group",
    invitationReceived: "You receive an invitation",
    invitationAccepted: "Someone accepts an invitation",
    listUpdated: "A list is updated",
    commentReceived: "New comment posted",
  }

  const updateNotifications = async (path, value) => {
    const updatedNotifications = set(notifications, path, value);
    const [error, updatedUser] = await Api.updateSettings({ notifications: updatedNotifications });
    if (error) {
      toast.error(Api.error(error));
      return console.error(error);
    }
    updateUser(updatedUser);
  }

  return (
    <div className={className}>
      <div className='row heading'>
        <div className='category'>Toggle All</div>
        <input
          type='checkbox'
          checked={notifications.enabled}
          className='setting'
          onChange={e => updateNotifications('enabled', e.target.checked)} />
      </div>
      <div className='row heading'>
        <div className='category'>Event</div><div>Email</div><div>SMS</div><div>Push</div>
      </div>
      {Object.entries(notifications.events).map(([category, values]) => {
        return (
          <div className='row'>
            <div className='category'>
              {NOTIFICATIONS_LABELS[category]}
            </div>
            {Object.entries(values).map(([key, value]) => {
              return (
                <input
                  className='setting'
                  type='checkbox'
                  disabled={!notifications.enabled || key === 'sms'}
                  checked={value}
                  onChange={e => updateNotifications(`events.${category}.${key}`, e.target.checked)}
                />
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
)`${notificationStyles}`;

const styles = css`
${accountStyles}

  /* & .title {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    & >.name {
      font-size: larger;
      font-weight: bold;
      }
  } */
  > .section {
    padding-left: 10px;
    padding-bottom: 20px;
  }
`;
const Settings = styled(({ className }) => {

  return (
    <div className={className}>
      <Title title='Settings' />
      <h3>Notifications</h3>
      <div className='section'>
        <NotificationsList />
      </div>
      <h3>Proxy Settings</h3>
      <div className='section' >
        <ProxySettings />
      </div>
    </div >
  )
})`${styles}`;

export default Settings;